// Workspace Imports
import { model, graphics, text } from "GenAlphaModel";

// # Drawn Text Orientation
//
// Adds the parent-based `reflect`ion field to the data-model `TextOrientation`.
//
export type DrawnTextOrientation = graphics.TextOrientation & {
  reflect: model.core.Reflect;
};
export const DrawnTextOrientation = {
  //
  // Convert the combination of a `TextOrientation` and its parent `Orientation` into a new, "resolved" `DrawnTextOrientation`.
  //
  // # NOTE:
  //
  // This is, like, the most painfully laboriously written, screwed-up, re-written, broken again, re-written function in the whole code base.
  // SERIOUSLY DONT FUCK AROUND. If you don't have, like, the rest of the afternoon, THESE ARE NOT THE DROIDS YOURE LOOKING FOR DAN.
  //
  // Every so often we get smart and figure out ways to streamline it, and then break them.
  // The best approach we've landed on is that 16-clause if-else tree, covering every combination of parent and child orientations.
  // If you, like, know a better, or more understandable way, please teach Dan about it.
  //
  fromParent: (
    child: graphics.TextOrientation,
    parent: { xform: model.Xform }
  ): DrawnTextOrientation => {
    const { R0, R90, R180, R270 } = model.Rotation;
    const parentOrient = model.Xform.orientation(parent.xform);

    let reflect: model.core.Reflect;
    let { alignment, baseline } = child;

    const eq = (
      parentReflected: boolean,
      parentRotation: model.Rotation,
      childTextRotation: text.TextRotation
    ): boolean => {
      return (
        parentReflected === parentOrient.reflected &&
        parentRotation === parentOrient.rotation &&
        childTextRotation === child.rotation
      );
    };

    // This is, really, the core logic here.
    // Explicitly spell out all sixteen possible cases, and what to do in each.
    if (
      eq(false, R0, R0) || // Easy Mode.
      eq(false, R0, R90) || // Nothing to do here.
      eq(false, R90, R0) || // Leave the text orientation as-is.
      eq(false, R270, R90) // This last case is slightly less obvious, represents wrapping around 360.
    ) {
      reflect = { horiz: false, vert: false };
      //
    } else if (
      eq(false, R90, R90) ||
      eq(false, R180, R0) ||
      eq(false, R180, R90) ||
      eq(false, R270, R0)
    ) {
      reflect = { horiz: true, vert: true };
      alignment = graphics.Alignment.opposite(alignment);
      //
    }
    // These cases in which the parent is reflected are the fun ones.
    // Be especially careful when screwing around in here.
    else if (eq(true, R0, R0)) {
      reflect = { horiz: false, vert: true };
    } else if (eq(true, R0, R90)) {
      reflect = { horiz: false, vert: true };
      alignment = graphics.Alignment.opposite(alignment);
    } else if (eq(true, R90, R0)) {
      reflect = { horiz: false, vert: true };
    } else if (eq(true, R90, R90)) {
      reflect = { horiz: true, vert: false };
    } else if (eq(true, R180, R0)) {
      reflect = { horiz: true, vert: false };
      alignment = graphics.Alignment.opposite(alignment);
    } else if (eq(true, R180, R90)) {
      reflect = { horiz: true, vert: false };
    } else if (eq(true, R270, R0)) {
      reflect = { horiz: true, vert: false };
      alignment = graphics.Alignment.opposite(alignment);
    } else {
      // (eq(true, R270, R90)) {
      reflect = { horiz: false, vert: true };
      alignment = graphics.Alignment.opposite(alignment);
    }

    // NOTE: this `baseline` logic is probably the lowest-confidence part of this.
    // It *probably* needs to get more mixed up in that if-else tree.
    // But it's also aways harder to say, as far fewer schematics use anything but the default `middle` justification.
    if (reflect.vert) baseline = graphics.Baseline.opposite(baseline);

    // Return the combination as a new `TextOrientation`
    return { alignment, baseline, rotation: child.rotation, reflect };
  },
};
